import { useEffect } from 'react';

function isHorizontalScrollContainer(element: Element): boolean {
  const htmlElement = element as HTMLElement;
  const style = window.getComputedStyle(htmlElement);
  const canScrollHorizontally = htmlElement.scrollWidth > htmlElement.clientWidth;
  const allowsHorizontalScroll = style.overflowX === 'auto' || style.overflowX === 'scroll';

  return canScrollHorizontally && allowsHorizontalScroll;
}

/**
 * Keeps carousels from stealing horizontal wheel/trackpad gestures.
 * Vertical wheel movement is left fully native so page momentum stays smooth.
 */
export function usePageWheelPriority() {
  useEffect(() => {
    const handleWheel = (event: WheelEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const horizontalContainer = target.closest('.hide-scrollbar');
      if (!horizontalContainer || !isHorizontalScrollContainer(horizontalContainer)) return;

      const horizontalIntent = Math.abs(event.deltaX) > Math.abs(event.deltaY);
      if (!horizontalIntent) return;

      event.preventDefault();
    };

    window.addEventListener('wheel', handleWheel, { capture: true, passive: false });
    return () => window.removeEventListener('wheel', handleWheel, { capture: true });
  }, []);
}
